import { apiGeneral, queryBuilder } from "services";

export function useCompanyProfit() {
  const getListCompanyProfit = async (payload: any) => {
    const queryString = queryBuilder(payload);
    const { data } = await apiGeneral.get(`/companies-profit?${queryString}`);
    return data.map((el: any) => ({
      label: `${el.code} - (${el.businessLine.activity_division } - ${el.businessLine.description} )  `,
      value: el.id,
    }));
  };
  return {
    getListCompanyProfit,
  };
}
